import { TabPane } from 'reactstrap';
export default TabPane;